import React from 'react';
import { Route, Routes, } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Activation from '../../features/Activation/Activation';
import AppFooter from '../../features/footer/AppFooter';
import Home from '../../features/home/Home';
import LookUp from '../../features/LookUp/LookUp';
import NotFound from '../../features/NotFound/NotFound';

import NavBar from './NavBar';

function App() {

    return (
        <div className='app_body_content'>
            <ToastContainer position="bottom-right" hideProgressBar />
            <NavBar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path='/lookup' element={<LookUp />} />
                <Route path='/activation' element={<Activation />} />
                <Route path='*' element={<NotFound/>} />
            </Routes>
            
            <AppFooter />
        </div>
    );
}

export default App;